import type {TuiLanguageTable} from '@taiga-ui/i18n/types';

export const TUI_ENGLISH_LANGUAGE_ADDON_TABLE: TuiLanguageTable = {
    showHideText: 'Show/Hide',
    paginationTexts: {
        pages: 'Pages',
        linesPerPage: 'Lines per page',
        of: 'of',
    },
};
